export default "__VITE_ASSET__DVTUtpHi__"